import React from 'react';

import AbstractToggle from './AbstractToggle';
import Toggle from './Toggle';

import { isiOS } from 'config';
import androidCheckIcon from 'inline-icons/android-installed-check.svg';
import iOSCheckIcon from 'inline-icons/ios-installed-check.svg';

const checkIcon = isiOS ? iOSCheckIcon : androidCheckIcon;

export default class Checkbox extends AbstractToggle {
  render() {
    let dangerouslySetInnerHTML;
    if (this.props.checked) {
      dangerouslySetInnerHTML = { __html: checkIcon };
    }
    return (
      <Toggle
        checked={!!this.props.checked}
        onClick={this.onChange}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      />
    );
  }
}
